import appStrings from '@/app/utility/string.utility';
import expiryAlert from './expiryAlert';
import { required } from 'vuelidate/lib/validators';
import status from "./status";
import Highcharts from 'highcharts';
import dashboardDetail from './dashboardDetail';
import RunRequest from '../../../request/submittedRequest/runRequest';

export default {
  name: 'locationDash',
  components: { 
    expiryAlert,
    status,
    dashboardDetail,
    RunRequest
   },
  data() {
    return {
      siteName:null,
      locSearch:null,
      erpLoctnOrgId:null,
      locId:null,
      purchaseOrder: null,
      serialNumber: null,
      assetType: null,
      model: null,
      loader: false,
      isOpen: true,
      showValueSetModal:false,
      currentLoc: {
        text: null,
        value: null
      },
      downloadDashboardData:[],
      locationDashData: [],
      locationDashFields: [
        {
          key: 'value_code',
          label:"",
          class:"value_code_font"
        },
        {
          key: 'count_30',
          label:'Range 30',
          class:"alignItem"
        },
        {
          key: 'count_50',
          label: 'Range 50',
          class:"alignItem"
        },
        {
          key: 'count_100',
          label:'Range 100',
          class:"alignItem"
        },
        {
          key:'count_150',
          label: 'Range 150',
          class:"alignItem"
        },
        {
          key:'count_200',
          label: 'Range 200',
          class:"alignItem"
        },
        {
          key:'count_250',
          label: 'Range 250',
          class:"alignItem"
        },
        {
          key:'count_300',
          label: 'Range 300',
          class:"alignItem"
        },
        {
          key:'count_350',
          label: 'Range 350',
          class:"alignItem"
        },
        {
          key:'count_400',
          label: 'Range 400',
          class:"alignItem"
        },
        {
          key:'count_500',
          label: 'Range 500',
          class:"alignItem"
        },
        {
          key:'count_600',
          label: 'Range 600',
          class:"alignItem"
        },
        {
          key:'count_1000',
          label: 'Range 1000',
          class:"alignItem"
        },
        {
          key:'count_2500',
          label: 'Range 2500',
          class:"alignItem"
        },
        {
          key:'count_max',
          label: 'Range 3000',
          class:"alignItem"
        }
      ],
      showHideAssetAuditModalFlag:false,
      showDashDetailFlag:false,
      faId:null,
      dashData:{
        count: null
      },
      range30 : 0,      
      range50 : 0,     
      range100 : 0,
      range150 : 0, 
      range200 : 0,
      range250 : 0,
      range300 : 0,
      range350 : 0,
      range400 : 0,
      range500 : 0,
      range600 : 0,
      range1000 : 0,
      range2500 : 0,
      range3000 : 0,
      chartFlag: false,
      chartData:[],
      showExpiryAlertFlag:false,
      showStatusDocModalFlag:false,
      accessButtons:{},
      locAccessFlag:false,
      dashFlag:true,
      payload:{},
      userEmpId:null,
      isChartVisible: true,
      valSize:'0',
      showRunRequestModal: false,
      reqRun: {}
    };
  },
  validations: {
    currentLoc: {
      text: {
        required
      }
    },
  },
  mounted() {
    this.totalLines();
    this.getUsersDetails();
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (
          actionName === 'download' && !this.showHideAssetAuditModalFlag && !this.showDashDetailFlag
        ) {
          if(this.currentLoc.text){
            this.loader = true;
            const downloadpayload = { ...this.payload };
            // downloadpayload._limit = this.totalRows;
            this.downloadExcel.downloadData(
              downloadpayload,
              'assets/getWeighingDashboardData',
              'fa-getDashboard',
              () => (this.loader = false),
              this.downloadDashboardData,
            );
          }else{
            this.$bvToast.toast("Kindly select a location from search parameter", {
              title: 'Alert',
              variant: 'danger',
              solid: true
            });
          }
        
        }
      }
    });
  },
  methods: {
    totalLines() {
      let range30 = this.range30;
      let range50 =this.range50;
      let range100 =this.range100;
      let range150=this.range150; 
      let range200 = this.range200;
      let range250=this.range250;
      let range300=this.range300;
      let range350=this.range350;
      let range400= this.range400;
      let range500=this.range500;
      let range600=this.range600;
      let range1000=this.range1000;
      let range2500=this.range2500;
      let range3000=this.range3000;
      // if(this.currentLoc.text=="YamunaNagar_DC (Haryana)"){
        this.chartData = [
          ['Range 30', range30],
          ['Range 50', range50],
          ['Range 100', range100],
          ['Range 150', range150],
          ['Range 200', range200],
          ['Range 250', range250],
          ['Range 300', range300],
          ['Range 350', range350],
          ['Range 400', range400],
          ['Range 500', range500],
          ['Range 600', range600],
          ['Range 1000', range1000],
          ['Range 2500', range2500],
          ['Range 3000', range3000]
        ];
      this.chartFlag = true;
      this.showCharts()
    },
    toggleSidebar() {
      this.isOpen = !this.isOpen;
    },
    openValueSetModal(vsetCode) {
      this.vsetCode = vsetCode;
      this.showValueSetModal = true;
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    selectedvalueSet(item) {
      if(this.vsetCode === appStrings.VALUESETTYPE.LOCATION){
        this.currentLoc = {
          value: item.value_set_dtl_id,
          text: item.value_code,
        };
        this.locId=item.loc_id
        this.erpLoctnOrgId = item.erp_loc_org_id;
        this.faId=item.fa_loc_id;
        if(this.locId){
          this.getWeighingDashboardData()
        }
      }
    },
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
    clearVsetValues(vsetCode) {
      this.vsetCode=vsetCode
      if(this.vsetCode === appStrings.VALUESETTYPE.LOCATION){
        this.currentLoc = {
          value: null,
          text: null
        }
        this.locationDashData= []
        this.range30 = 0;
        this.range50 = 0;
        this.range100 = 0;
        this.range150 = 0; 
        this.range200 = 0;
        this.range250 = 0;
        this.range300 = 0;
        this.range350 = 0;
        this.range400 = 0;
        this.range500 = 0;
        this.range600 = 0;
        this.range1000 = 0;
        this.range2500 = 0;
        this.range3000 = 0;
        this.totalLines();
        this.showCharts();
        this.eventBus.$emit('upData', false)
      }
    },
    clearData() {
      this.currentLoc = {
        value: null,
        text: null
      };
      this.locationDashData= []
    },
    showDashDetailModal(flag,status,count,qty){
      this.showDashDetailFlag=flag
      if(this.showDashDetailFlag)
      {
        this.dashData={
          count: count,
          assetStatus: status,
          assetQty: qty,
        }
    }else{
      // this.getWeighingDashboardData()
    }
    if(flag && !this.locAccessFlag) {
      this.accessButtons = {
        deleteAllow: false,
        downloadAllow: false,
        uploadAllow: false,
        editAllow: false,
        addAllow: false,
        printAllow: false,
        approvalAllow: false
      };
    }else{
      this.accessButtons = {
        deleteAllow: false,
        downloadAllow: true,
        uploadAllow: false,
        editAllow: true,
        addAllow: true,
        printAllow: false,
        approvalAllow: false
      };
    }
  },
  getWeighingDashboardData(){
    this.dashFlag = false;
    this.range30 = 0;
    this.range50 = 0;
    this.range100 = 0;
    this.range150 = 0; 
    this.range200 = 0;
    this.range250 = 0;
    this.range300 = 0;
    this.range350 = 0;
    this.range400 = 0;
    this.range500 = 0;
    this.range600 = 0;
    this.range1000 = 0;
    this.range2500 = 0;
    this.range3000 = 0;
    this.payload = {
       hr_loc: this.locId,
    };
    this.loader = true;
    this.$store
      .dispatch('weighMachine/getWeighingDashboardData', this.payload)
      .then(resp => {
        this.loader = false;
        if (resp.status === 200) {
          this.dashFlag=true;
          this.locationDashData = resp.data.data;
          for(let i=0;i<this.locationDashData.length;i++){
             this.range30 += this.locationDashData[i].count_30;
             this.range50 += this.locationDashData[i].count_50;
             this.range100 += this.locationDashData[i].count_100;
             this.range150 += this.locationDashData[i].count_150;
             this.range200 += this.locationDashData[i].count_200;
             this.range250 += this.locationDashData[i].count_250;
             this.range300 += this.locationDashData[i].count_300;
             this.range350 += this.locationDashData[i].count_350;
             this.range400 += this.locationDashData[i].count_400;
             this.range500 += this.locationDashData[i].count_500;
             this.range600 += this.locationDashData[i].count_600;
             this.range1000 += this.locationDashData[i].count_1000;
             this.range2500 += this.locationDashData[i].count_2500;
             this.range3000 += this.locationDashData[i].count_max;

          }
        //   this.locationDashData.push({
        //     value_code:'TOTAL',
        //     count_30:this.laptopQty,
        //     hhd_qty:this.hhdQty,
        //     scanner_qty:this.barcodeScanner,
        //     printer_qty:this.hipPrinter,
        //     bar_printer_qty:this.barcodePrinter,
        //     cpu_qty: this.cpuQty,
        //     monitor_qty:this.monitorQty,
        //     wireless_scanner_qty:this.wirelessScannerQty,
        //     wired_scanner_qty:this.wiredScannerQty,
        //     switch_qty:this.switchQty,
        //     access_point_qty:this.accessPointQty,
        //     server_qty:this.serverQty,
        //     firewall_qty:this.firewallQty,
        //     others:this.otherAssetsQty,
        //   })
        //   this.locationDashData.map(item=>{
        //     this.downloadDashboardData.push(
        //       {
        //        location:item.hr_loc_name, 
        //        status:item.value_code,
        //        laptop:item.count_30,
        //        hhd:item.hhd_qty,
        //        hip_printer:item.printer_qty,
        //        barcode_printer:item.bar_printer_qty,
        //        cpu:item.cpu_qty,
        //        monitor:item.monitor_qty,
        //        wireless_scanner:item.wireless_scanner_qty,
        //        wired_scanner:item.wired_scanner_qty,
        //        switch:item.switch_qty,
        //        access_point:item.access_point_qty,
        //        server:item.server_qty,
        //        firewall:item.firewall_qty,
        //        other_assets:item.others
        //       }
        //     )
        //   })
          // this.locationDashData.map(ele=>{
          //   ele.bar_printer_qty=Number(ele.bar_printer_qty)
          //   ele.hhd_qty=Number(ele.hhd_qty)
          //   ele.count_30=Number(ele.count_30)
          //   ele.printer_qty=Number(ele.printer_qty)
          // })
          this.totalRows = resp.data.data.total_elements;
          this.totalLines()
        }
      })
      .catch(() => {
        this.loader = false;
      });
  },
  showOpenExpiryAlertModal(flag) {
      this.showExpiryAlertFlag = flag;
    if(!flag){
      // this.getWeighingDashboardData()
    }
    if(flag && !this.locAccessFlag) {
      this.accessButtons = {
        deleteAllow: false,
        downloadAllow: false,
        uploadAllow: false,
        editAllow: false,
        addAllow: false,
        printAllow: false,
        approvalAllow: false
      };
    }else{
      this.accessButtons = {
        deleteAllow: true,
        downloadAllow: false,
        uploadAllow: false,
        editAllow: true,
        addAllow: true,
        printAllow: false,
        approvalAllow: false
      };
    }
  },
  showCharts(){
    Highcharts.chart('chart-container1', {
      chart: {
        type: 'pie',
        height: 410,
        width:430,
        borderRadius:18,
        backgroundColor: 'rgb(255,255,255)',
      },  
      title: {
        text: this.currentLoc.text?this.currentLoc.text+'<br/>'+'Dashboard Status':'Dashboard Status',
        style:{
          color: 'black',
          fontWeight:'bold'
        }
      },
      plotOptions: {
        pie: {
           allowPointSelect: true,
            cursor: 'pointer',          
          dataLabels: {
            enabled: true,
            color:'black',
            format:  '<b>{point.name}</b><br>{point.percentage:.1f}%',
            style: {
              fontFamily: 'Open Sans',
              fontWeight:'x-small',
              textOutline:'none'
            },
            distance:20,
          }
        }
      },
        tooltip:{
       style: {
              fontFamily: 'Open Sans',
            }
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false
      },
      series: [
        {
          name: 'Data',
          size: '70%',
          data: this.chartData,
          innerSize: '30%',
        }
      ]
    });
  },
  showHideStatusModal(flag){
    this.showStatusDocModalFlag=flag
    if (flag) {
      this.accessButtons = {
        deleteAllow: false,
        downloadAllow: false,
        uploadAllow: false,
        editAllow: false,
        addAllow: false,
        printAllow: false,
        approvalAllow: false
      };
    }
    if(!flag){
      // this.getWeighingDashboardData()
    }
  },
  getData(){
    if(this.currentLoc.text){
      this.getWeighingDashboardData()
    }
    else{
      this.$bvToast.toast("Kindly select a location from search parameter", {
        title: 'Alert',
        variant: 'danger',
        solid: true
      });
    }
  },
  getUsersDetails() {
      this.$store.dispatch('auth/getUserDetail').then(response => {
        if (response.status === 200) {
          this.userEmpId = response.data.data.employee_id;
        }
      });
  },
  toggleChart() {
    this.isChartVisible = !this.isChartVisible;
    if(!this.isChartVisible){
      this.valSize='12'
    }else{
      this.valSize='8'
    } 
  },
  runRequest() {
    this.showRunRequestModal = true;
  },
  resetModal() {
    this.showRunRequestModal = false;
  }
},
  beforeDestroy() {
    this.unsubscribe();
  }
};

